export const AUTOMATIC_QUESTION_FORM_TYPES = {
  financial_pendency: 'Pendência Financeira',
  pep: 'Pessoa exposta politicamente',
  partnerships: 'Participação societária',
  processes: 'Processos',
  restriction_list: 'Lista Restritiva',
  negative_media: 'Mídia Negativa',
}
